import axiosInstance from "./Utils/axiosInstance";

export class TechnicianTimesheet {
  static async fetchTimesheetData(payload) {
    try {
      const { data } = await axiosInstance.post(
        "/service/timesheet-data-service/1.0/workHoursForDay",
        payload
      );
      return data;
    } catch (error) {
      throw error;
    }
  }
  static async fetchCentralTimesheetData(payload) {

    try {
      let date = new Date();
      payload.offsetTime = date.getHours() + ':' + date.getMinutes();
      const { data } = await axiosInstance.post(
        "/service/timesheet-data-service/1.0/centralWorkHours",
        payload
      );
      return data;
    } catch (error) {
      throw error;
    }
  }
  static async fetchMonthTimesheetData(payload) {
    try {
      const { data } = await axiosInstance.post(
        "/service/timesheet-data-service/1.0/technicianTimesheet",
        payload
      );
      return data;
    } catch (error) {
      throw error;
    }
  }
  static async updateTimesheetData(payload) {
    try {
      const { data } = await axiosInstance.post(
        "/service/timesheet-crud-service/1.0/updateTechnicianTimesheet",
        payload
      );
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async updateTimesheetDataPopup(payload) {
    try {
      const { data } = await axiosInstance.post(
        "/service/timesheet-crud-service/1.0/updateTechnicianWorkHour",
        payload
      );
      return data;
    } catch (error) {
      throw error;
    }
  }

  // static async updateTechnicianCallout(payload) {
  //   try {
  //     const { data } = await axiosInstance.post(
  //       "/service/timesheet-crud-service/1.0/updateTechnicianCallout",
  //       payload
  //     );
  //     return data;
  //   } catch (error) {
  //     throw error;
  //   }
  // }
}
